import type { VisualEditorCommand } from '../editor-types';

/** Meta/Ctrl formatting shortcuts for the visual editor iframe. */
export const resolveFormatShortcutCommand = (event: Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'altKey' | 'shiftKey'>): VisualEditorCommand | null => {
    if (!(event.metaKey || event.ctrlKey) || event.altKey || event.shiftKey) return null;

    switch (event.key.toLowerCase()) {
        case 'b':
            return { type: 'bold' };
        case 'i':
            return { type: 'italic' };
        case 'u':
            return { type: 'underline' };
        default:
            return null;
    }
};
